import { api } from 'app/config/apiConfig';

import { Box } from '../model/types';

export const updateBoxApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateBox: builder.mutation<Box, Partial<Box>>({
      query: (box) => ({
        url: `/boxes/${box.boxId}`,
        method: 'PUT',
        body: box,
      }),
      invalidatesTags: ['Boxes', 'Available boxes', 'Price History'],
    }),
  }),
});

export const { useUpdateBoxMutation } = updateBoxApi;
